const PREFIX = "wes.ordh.v1";
const TTL_MINUTES = Number(process.env.REACT_APP_ORDER_HISTORY_CACHE_TTL_MIN || 5);
const TTL_MS = TTL_MINUTES * 60 * 1000;

const store = () => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

const trySet = (ls, key, payload) => {
  try {
    ls.setItem(key, payload);
    return true;
  } catch {
    return false;
  }
};

export const buildKey = ({ userId, fromDate, toDate, searchString, sortColumn, sortDir, pageNo }) =>
  [
    PREFIX,
    userId ?? "",
    fromDate ?? "",
    toDate ?? "",
    searchString ?? "",
    sortColumn ?? "",
    sortDir ?? "",
    pageNo,
  ].join("|");

export const readPage = (key) => {
  const ls = store();
  if (!ls) return null;
  try {
    const raw = ls.getItem(key);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (!entry || !Array.isArray(entry.rows)) return null;
    if (Date.now() - entry.t > TTL_MS) {
      ls.removeItem(key);
      return null;
    }
    return { rows: entry.rows, total: entry.total };
  } catch {
    return null;
  }
};

export const writePage = (key, { rows, total }) => {
  const ls = store();
  if (!ls) return;
  const payload = JSON.stringify({ t: Date.now(), rows, total });
  if (trySet(ls, key, payload)) return;
  clearAll();
  trySet(ls, key, payload);
};

export const clearAll = () => {
  debugger;
  const ls = store();
  if (!ls) return;
  try {
    for (let i = ls.length - 1; i >= 0; i--) {
      const key = ls.key(i);
      if (key && key.startsWith(PREFIX)) {
        ls.removeItem(key);
      }
    }
  } catch {
    return;
  }
  // const ss = sessionStore();
  // if (!ss) return;
  // try {
  //   for (let i = ss.length - 1; i >= 0; i--) {
  //     const key = ss.key(i);
  //     if (key && key.startsWith(PREFIX)) {
  //       sessionStorage.removeItem(key);
  //     }
  //   }
  // } catch {  
  //   return;
  // }
};

const VIEW_STATE_KEY = `${PREFIX}|view`;

const sessionStore = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const buildViewSignature = ({ userId, fromDate, toDate, searchString }) =>
  [userId ?? "", fromDate ?? "", toDate ?? "", searchString ?? ""].join("|");

export const saveViewState = (signature, state) => {
  const ss = sessionStore();
  if (!ss) return;
  try {
    ss.setItem(VIEW_STATE_KEY, JSON.stringify({ signature, state }));
  } catch {
    return;
  }
};

export const readViewState = (signature) => {
  const ss = sessionStore();
  if (!ss) return null;
  try {
    const raw = ss.getItem(VIEW_STATE_KEY);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (!entry || entry.signature !== signature) return null;
    return entry.state || null;
  } catch {
    return null;
  }
};

const FILTER_STATE_KEY = `${PREFIX}|filters`;

export const saveFilterState = (userId, { startDate, endDate, searchString }) => {
  const ss = sessionStore();
  if (!ss) return;
  try {
    ss.setItem(
      FILTER_STATE_KEY,
      JSON.stringify({
        userId: String(userId ?? ""),
        startDate: startDate ?? "",
        endDate: endDate ?? "",
        searchString: searchString ?? "",
      }),
    );
  } catch {
    return;
  }
};

export const readFilterState = (userId) => {
  const ss = sessionStore();
  if (!ss) return null;
  try {
    const raw = ss.getItem(FILTER_STATE_KEY);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (!entry || entry.userId !== String(userId ?? "")) return null;
    if (!entry.startDate || !entry.endDate) return null;
    //ss.removeItem(FILTER_STATE_KEY);
    return { startDate: entry.startDate, endDate: entry.endDate, searchString: entry.searchString || "" };
  } catch {
    return null;
  }
};
